import React, { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "../../ProtectedRoute/AppContext"; // Import useAuth from AuthContext

import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { userLogin } from "../../Services/AccountServices";
import logo from '../../assets/images/logo.png'; 
import Loader from "../../DesignLayout/Loader/Loader";

function Login() {
  const [Loading,setLoading]=useState(false);
  const [username, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const { login } = useAuth(); // Use login from AuthContext
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    const params = { username, password };
setLoading(true);
    try {
     await userLogin(params).then((response=>{
        if (response.data) {
          login(response.data); // Save the response to the context
          toast.success(`Login successful! Welcome, ${response.data.role}`);
          navigate("/"); // Redirect to the dashboard
        } else {
          toast.error("Login failed: Incorrect username or password");
        }
      }));

      
    } catch (err) {
      toast.error("Login failed: Incorrect username or password.");
    }
    finally{
      setLoading(false);
    }
  };

  return (
    <div>
      {/* <nav className="navbar navbar-expand-lg navbar-light bg- px-0 py-2 fixed-top">
  <div className="container-xl">
    <a className="navbar-brand" href="#">
      <img src={logo} width={220} className="h-8" alt="..." />
    </a>
   
  
  </div>
</nav> */}

    <div className="container-fluid ">
      <ToastContainer />
      <Loader loading={Loading} />
      <div className="row body vh-100 d-flex justify-content-center align-items-center" >
        <div className="col-lg-4 col-md-4 col-sm-12">
          <div className="text-center pt-3 pb-3">
          <img src={logo} width={220} className="h-8" alt="..." />
          </div>
       
          <div className="logform p-4 shadow-lg">
            <h3 className="text-center mb-4" style={{fontSize:"1.3em"}}>Login to your account</h3>
            <form onSubmit={handleSubmit}>
              <div className="form-floating mb-3">
               
                <input
                  type="text"
                  id="username"
                  className="form-control"
                  value={username} placeholder="Username"

                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
                 <label htmlFor="username">Username</label>
              </div>

              <div className="form-floating mb-3">
               
                <input
                  type="password"
                  id="password"
                  className="form-control text-start"
                  value={password} placeholder="Password"

                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
                 <label htmlFor="password">Password</label>
              </div>

              <div className="d-flex justify-content-between mb-3">
                <NavLink to="/forgot-password" className="text-primary text-decoration-none">
                  Forgot Password?
                </NavLink>
              </div>
              <button type="submit" className="btn btn-primary w-100">
                Login
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
     </div>
  );
}

export default Login;
